import { initialState as initialStateAddAdvert } from 'utils/state-managment/user/userAddAdvert';
import { OrganizationRole } from 'utils/types/BrokerModels';
import {
    BoxEditDto, BoxEditDtoModuleEnum, BoxInfoDto,
    CapitalDetailDto, CapitalEditDto, DealDetailDto,
    DealEditDto, InvestorDetailDto,
    InvestorEditDto
} from 'utils/types/UserModels';
import { UserAdvertEditReturnData } from 'utils/types/UsersAdvert';
import { ActivePackageDto, AiTokenDto, MyDataDto, NotificationInfoDto } from 'utils/types/UserSettingsModels';

export enum MessageSenders {
    AD_OWNER = 'AD_OWNER',
    INTERESTED = 'INTERESTED'
}

export enum MessagesAdvertType {
    BUY = 'buy',
    SALE = 'sale',
}

export interface NotesType {
    noteId: number,
    ownerId: string,
    content: string,
    date: string,
    originalNote: boolean,
}

type UserOfferDetailsResponseDto = InvestorDetailDto & DealDetailDto & CapitalDetailDto;

type OfferResponseDto = BoxInfoDto;

type MyOfferDetailsResponseDto = InvestorEditDto & DealEditDto & CapitalEditDto;

export interface UserOffersResponseContent extends OfferResponseDto {
    detailedContent?: UserOfferDetailsResponseDto;
}
export interface UserProfileOffersResponseContent extends BoxInfoDto {
    detailedContent?: UserOfferDetailsResponseDto;
}
export interface UserMyOffersResponseContent extends BoxEditDto {
    detailedContent?: MyOfferDetailsResponseDto;
}

interface OffersResponse {
    last: boolean;
    empty: boolean,
    pageable: {
        pageNumber: number,
        pageSize: number,
    },
    numberOfElements: number,
    totalElements?: number,
    totalPages: number,
    size: number,
}

interface UserOffersResponse extends OffersResponse {
    content: UserOffersResponseContent[],
}

interface UserProfileOffersResponse extends OffersResponse {
    content: UserProfileOffersResponseContent[];
}

interface UserMyOffersResponse extends OffersResponse {
    content: UserMyOffersResponseContent[],
}

interface LastUserMessages {
    lastMessageId: string,
    name: string,
    content: string,
    sendDate: string,
    messageSender: MessageSenders,
    newMessage: boolean,
    photo?: string,
}

export interface UserMessages {
    content: string,
    messageId: string,
    messageSender: MessageSenders,
    readTime: string | null,
    sendDate: string
}

export interface UserMessageListResponse {
    title: string,
    price: number | null,
    messages: LastUserMessages[],
    module: BoxEditDtoModuleEnum,
    mainPhoto: string | null,
    photo?: string,
    advertisementId: string,
}

export interface State {
    isLoading: boolean,
    isLogged: boolean,
    activePackages: string[],
    user: object,
    token: string,
    refreshToken: string,
    isInOrganization: boolean,
    organizationRole: OrganizationRole | string,
    userRole: string,
    isWordpressUser: boolean,
    isDarkMode: boolean,
    isInputError: boolean,
    usersOfferList: UserOffersResponse,
    myOfferList: UserMyOffersResponse,
    notes?: NotesType[],
    profileOfferList: UserProfileOffersResponse,
    offerToEdit: UserAdvertEditReturnData,
    profile: MyDataDto,
    userMessageList: UserMessageListResponse[],
    notificationSettings: NotificationInfoDto,
    tokenInfo: AiTokenDto,
    activePackageInfo: ActivePackageDto,
}

export const initialState: State = {
    isLoading: false,
    isLogged: false,
    activePackages: [],
    profile: {
        profileUuid: '',
        name: '',
        email: '',
        profileName: '',
        profileEmail: '',
        profilePhone: '',
        description: '',
        userPhoto: ''
    },
    notificationSettings: {
        totalMonthSmsToUse: '',
        monthSmsToUse: '',
        boughtSms: 0,
        smsDayLimit: 0,
        smsDayReset: '',
        activeNotification: true,
        pushNotification: true,
        notificationEmail: '',
        notificationPhone: '',
        smsPackage: 0,
        smsToUsed: 0
    },
    tokenInfo: {
        monthAiTokensToUse: '',
        boughtAiToken: 0,
        aiTokenReset: '',
        aiTokenPackage: 0,
        availableAiTokens: 0
    },
    activePackageInfo: {
        packageName: '',
        startDate: '',
        endDate: '',
        daysToEnd: 0
    },
    user: {},
    token: '',
    refreshToken: '',
    usersOfferList: {
        empty: false,
        content: [],
        pageable: {
            pageNumber: 0,
            pageSize: 0
        },
        numberOfElements: 0,
        totalPages: 0,
        size: 25,
        last: false
    },
    myOfferList: {
        empty: false,
        last: false,
        content: [],
        pageable: {
            pageNumber: 0,
            pageSize: 0
        },
        numberOfElements: 0,
        totalPages: 0,
        size: 25
    },
    profileOfferList: {
        last: false,
        empty: false,
        content: [],
        pageable: {
            pageNumber: 0,
            pageSize: 0
        },
        numberOfElements: 0,
        totalPages: 0,
        size: 25
    },
    // @ts-expect-error TODO: INVEST-237
    offerToEdit: { advertisementId: 0, ...initialStateAddAdvert.initialState() },
    userMessageList: [],
    isDarkMode: localStorage.getItem('darkTheme') === 'true',
    isInputError: false,
    isInOrganization: false,
    organizationRole: '',
    userRole: ''
};
